---
de:
  activerecord:
    models:
      comment:
        one: Kommentar
        other: Kommentare
  comments:
    add_comment: Kommentar hinzufügen
    notify_replies: Benachrichtige mich über neue Antworten
